import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PDFViewer from 'pdf-viewer-reactjs'
import { useHistory, useLocation } from 'react-router-dom';

import {
  ModalContent,
  PolicyTitle,
  DivisionCheckbox,
  DocumentContainer
} from "./styles";

import "~/components/styles/Global.css";
import "~/components/styles/Contracts.css";
import { useDispatch } from "react-redux";
import api from '~/services/api';
import CustomNavigation from "~/components/pages/Contracts/CustomNavigation";
import Loading from "~/components/layout/Loading";
import CheckBox from "~/components/layout/CheckBoxCustom";
import close_contract from "~/assets/images/close_contract.svg";

export default function ModalLGPD({
  showModal,
  activeModal,
  access_token,
  user
}) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [termsOfCondition, setTermsOfCondition] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(showModal);

  function getLGPDPolicy() {
    const header = {
      'Content-Type': 'application/json',
      access_token: access_token ? access_token : localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    api.get("/residential/store/v1/files?type=LGPD", parameters)
    .then((res) => {
      setAttachment(res.data.file);
      setLoading(false);
    })  
    .catch((err) => {})
  }
  
  useEffect(() => {
    if(modalOpen) {
      setLoading(true);
      getLGPDPolicy();
    }
  }, [modalOpen]);

  function handlePrivacy() {
    setLoading(false);
    setModalOpen(false);
    localStorage.setItem("lgpd", true);
    changeUser();
    dispatch({ type: "SET_LGPD", acceptLgpd: true });
    handleTraining();
  }

  async function changeUser() {
    const header = {
      'Content-Type': 'application/json',
      access_token: access_token ? access_token : localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      lgpdAccepted: true
    }
    await api
    .patch(`/residential/store/v1/users/${user.userId}`, body, parameters)
  }

  const handleTraining = () => {
    const privacyPolicy = localStorage.getItem('privacyPolicyFirst');
    const competitiveCompliance = localStorage.getItem('competitiveCompliance');
    if (privacyPolicy === "true" && competitiveCompliance !== "true") {
      dispatch({ type: 'SET_MODAL_HOME', openModalHome: true });
    } else {
      dispatch({ type: 'SET_OPEN', open: true, openNpsScript: false });
    }
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        setModalOpen(false);
        localStorage.setItem("lgpd", true);
        handleTraining();
      }}
      className="modal-contrato"
      centered={window.screen.width >= 768}
      scrollable={true}
    >
      <Modal.Body scrollable={true} style={{ 
        overflow: window.screen.width > 770 ? "scroll" : "hidden", 
        padding: ".5rem", 
        borderRadius: 15 
      }}>
        {
          loading ? <Loading margin="100% auto" /> : (
          <ModalContent>
            <PolicyTitle>
              <div />
              <span>Política LGPD</span>
              <img src={close_contract} alt="Ícone de fechar" onClick={() => {
                setAttachment(null);
                setModalOpen(false);
                localStorage.setItem("lgpd", true);
                handleTraining();
              }} />
            </PolicyTitle>
            {
              loading || attachment === null ? <Loading margin="100% auto" /> : (
                <DocumentContainer>
                  <PDFViewer
                    css="viewr"
                    document={{
                      base64: attachment,
                    }}
                    navigation={CustomNavigation} 
                    loader={<Loading margin="100% auto" />}
                    navbarOnTop               
                  />
                    <DivisionCheckbox>
                      <div className="message">
                        {[{ checked: termsOfCondition }].map(store => (
                          <CheckBox
                            checked={termsOfCondition}
                            className="checkbox"
                            label={`Confirmo que li e entendi o conteúdo.`}
                            title={`Confirmo que li e entendi o conteúdo.`}
                            onChange={() => setTermsOfCondition(!termsOfCondition)}
                          />
                        ))}
                      </div>
                      <div>
                        <button 
                        checked={termsOfCondition}
                        onClick={() => {
                          if(termsOfCondition) {
                            setLoading(true);
                            handlePrivacy();
                          }
                        }}>Confirmar</button>
                      </div>
                    </DivisionCheckbox>
                </DocumentContainer>
              )
            }
          </ModalContent>
          )
        }
      </Modal.Body>
    </Modal>
  );
}
